import React from 'react';
import { useTranslation } from 'react-i18next';

const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: 'sans-serif',
  } as React.CSSProperties,
  section: {
    backgroundColor: '#f9f9f9',
    padding: '1.5rem',
    marginBottom: '2rem',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
  } as React.CSSProperties,
  image: {
    maxWidth: '100%',
    height: 'auto',
    border: '1px solid #ddd',
    borderRadius: '8px',
    marginBottom: '2rem',
  } as React.CSSProperties,
  viewer: {
    width: '100%',
    height: '600px',
    border: '1px solid #ddd',
    borderRadius: '8px',
  } as React.CSSProperties,
};

export default function KITongHop() {
  const { t } = useTranslation();
  document.title = t('ki_summary_page.page_title');

  return (
    <div style={styles.container}>
      <img
        src="/images/thong-tin-ki/BrochureA.jpg"
        alt={t('ki_summary_page.image_alt')}
        style={styles.image}
      />
      <img
        src="/images/thong-tin-ki/BrochureB.jpg"
        alt={t('ki_summary_page.image_alt')}
        style={styles.image}
      />
      <img
        src="/images/thong-tin-ki/InforgraphicA.jpg"
        alt={t('ki_summary_page.image_alt')}
        style={styles.image}
      />
      <img
        src="/images/thong-tin-ki/InforgraphicB.jpg"
        alt={t('ki_summary_page.image_alt')}
        style={styles.image}
      />

      <div style={styles.section}>
        <video controls style={{ ...styles.viewer, border: 'none' }}>
          <source src="/videos/ki-tonghop/Clip.mp4" type="video/mp4" />
          {t('ki_summary_page.video_fallback')}
        </video>
      </div>
    </div>
  );
}